import styled from 'styled-components';

type Props = {
    showBorder?: boolean;
};
const CategoryCardContainer = styled.div<Props>`
    border: ${({ theme, showBorder }) =>
        showBorder
            ? `1px solid ${theme.Colors.Aliases.textLightSecondary}`
            : 0};
    padding:${({ theme, showBorder }) =>
        showBorder ? `0 ${theme.Spacing.spacing3x} ${theme.Spacing.spacing3x} ${theme.Spacing.spacing3x}` : `${theme.Spacing.spacing3x} 0 0 0`};
    margin-top: 0;
    margin-bottom: ${({ theme, showBorder }) =>
        showBorder ? `${theme.Spacing.spacing3x}` : 0};
`;

export default CategoryCardContainer;
